module.exports = __webpack_public_path__ + "static/media/1.fa5c0b8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9025/1.jpg
// module id = 873
// module chunks = 0